module.exports = __webpack_public_path__ + "ls.svg?3b26ed069970cacdcbf63c9314ad97e1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ls.svg
// module id = 1114
// module chunks = 27